export enum path_module_employee {
    applications = 'mis-postulaciones',
    chat = 'conversaciones',
    edit_profile = 'editar-perfil',
    form_basic = 'registro-basico',
    login = `login`,
    module = 'profesor',
    password = `recuperar-contrasena`,
    resume_send = 'instituciones',
}

export enum path_module_admin {
    recomendation = `consulta-recomendacion`,
    changeemployer = `seleccionar-institucion`,
    searchemployee = `candidatos`,
    employee = `profesor`,
    employee_profile = `perfil-profesor`,
    employer = `institucion`,
    salaries = `salarios`,
    login = `ingreso`,
    module = 'administracion',
    report = `reportes`,
    customer_success = 'customer-success',
    psycho_interview = 'entrevistas-psicolaborales',
    prospecting = 'prospeccion'
}

export enum path_module_public {
    advice = 'anuncios',
    advice_category = 'anuncios/s',
    changepass = 'cambiar-contrasena',
    employee_landing = 'campana/profesor/registro',
    employee_landing_facebook = 'campana/profesor/registro-lead',
    employee_term = 'terminos-y-condiciones/profesor',
    employer_term = 'terminos-y-condiciones/institucion',
    faq = 'preguntas-frecuentes',
    forbbiden = 'acceso-no-autorizado',
    institution_search = 'buscador-de-instituciones',
    home = '',
    landing_premium = 'recluta',
    landing_resume_send = 'landing/profesor/tirar-cv',
    landing_salary_study = 'landing/estudio-de-salarios',
    not_found = 'pagina-no-encontrada',
    resetpass = 'reestablecer-contrasena',
    verifyemail = 'verificacion-usuario',
    createpass = 'crear-contrasena',
    salaries = 'salarios',
    logout = 'logout',
    reload = 'rel',
    reference_validation = 'referencias/validacion',
    employer_contact = 'formulario-contacto',
    webinar_karin = 'webinar-karin',
    webinar_karin_discount = 'webinar-karin-beneficios',
    employer_contact_karin = 'contacto-ley-karin',
    reference_validation_ab = 'referencias/validacionab'
}

export enum path_module_employer {
    search_talent = `buscar-talento`,
    edit = `editar-perfil`,
    job = `anuncio`,
    job_list = `empleos`,
    login = `login`,
    module = 'institucion',
    module_complaint_channel = 'canal-de-denuncias',
    profile = 'perfil',
    password = `recuperar-contrasena`,
    changepass = 'cambiar-contrasena',
    complaint_channel = 'nuevo',
    complaints = 'denuncias',
    complaint_documentation = 'documentacion',
    complaint_protocol = 'protocolos',
    complaint_configuration = 'personalizacion-de-formulario',
    sign_up = `registro`,
    users = `usuarios`,
    psycho_interview = `entrevistas-psicolaborales`,
    membership_info = `tipo-de-cuenta`,
    manager = 'administracion',
    manager_area = `area`,
    manager_team = `equipo`,
    manager_organization_chart = `organigrama`,
    manager_position = `cargo`,
    notifications = 'notificaciones',
    certificates = 'certificados',
}

export enum path_module_complaint {
    module = `denuncias`,
    register = `registrar`,
    follow_up = `seguimiento`,
    not_found = `pagina-no-encontrada`,
}
